"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CryptoInvoice = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _decimal = _interopRequireDefault(require("decimal.js"));
var _Item = require("./Item");
var _AmountData = require("./AmountData");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CryptoInvoice = function CryptoInvoice(_ref) {
  var _transaction$amountDu;
  var transaction = _ref.transaction;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransaction'),
    t = _useTranslation.t;
  var isPosistive = !transaction.isFullyPaid ? transaction.isOverPaid : undefined;
  var convertedAmountDueConverted = new _decimal.default((_transaction$amountDu = transaction.amountDue) !== null && _transaction$amountDu !== void 0 ? _transaction$amountDu : 0).mul(transaction.transacted.price).abs().toString();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.currency')
  }, transaction.ticker), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.amount')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: transaction.amount.value,
    ticker: transaction.ticker,
    convertedValue: transaction.amount.converted
  })), transaction.baseAmount && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.baseAmount')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: transaction.baseAmount,
    ticker: transaction.baseTicker
  })), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.price')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: '1',
    ticker: transaction.ticker,
    convertedTicker: transaction.baseTicker,
    convertedValue: transaction.basePrice
  })), transaction.paidPrice && /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.paidPrice')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: '1',
    ticker: transaction.ticker,
    convertedTicker: transaction.baseTicker,
    convertedValue: transaction.paidPrice
  }))), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.amountPaid')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: transaction.paidAmount.value,
    ticker: transaction.ticker,
    convertedValue: transaction.paidAmount.converted,
    positive: isPosistive
  })), !transaction.isFullyPaid && /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.amountDue')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: transaction.amountDue,
    ticker: transaction.ticker,
    convertedValue: convertedAmountDueConverted,
    positive: transaction.isOverPaid,
    sign: isPosistive ? '+' : ''
  })));
};
exports.CryptoInvoice = CryptoInvoice;